import React from "react"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import { graphql, useStaticQuery, Link } from "gatsby"
import { buttonGreenViolet } from "@styles/ui"
import Container from "./structure/Container"

import tw from "twin.macro"

const Callout = ({ title, subtitle, buttontxt, href, images, shortHeight }) => {
  const { bgdesktop, bgmobile } = useStaticQuery(graphql`
    query {
      bgdesktop: file(relativePath: { eq: "shared/bg-callout.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1200, quality: 75, placeholder: BLURRED)
        }
      }
      bgmobile: file(relativePath: { eq: "shared/bg-callout-mobile.png" }) {
        childImageSharp {
          gatsbyImageData(width: 327, quality: 75, placeholder: BLURRED)
        }
      }
    }
  `)

  const imageData = withArtDirection(getImage(images?.bgdesktop || bgdesktop), [
    {
      media: "(max-width: 780px)",
      image: getImage(images?.bgmobile || bgmobile),
    },
  ])

  return (
    <Container className="pagination-callout">
      <div css={[tw`relative rounded-3xl min-h-[300px]`, shortHeight && tw`min-h-[196px] lg:(min-h-[240px])`]}>
        <GatsbyImage
          image={imageData}
          tw="!absolute top-0 left-0 z-[1] w-full rounded-3xl h-full object-cover"
          imgStyle={{ zIndex: 1, objectPosition: "top" }}
          alt=""
        />
        <div css={[tw`relative z-20 grid grid-cols-12 px-6 py-8 gap-6 md:(py-[7.5rem])`, shortHeight && tw`md:(py-[30px])`]}>
          <div tw="font-bold relative z-20 font-kanit tracking-[0.005rem] col-start-1 col-span-12 md:(col-start-2 col-span-8) lg:(col-start-2 col-span-5)">
            <div tw="text-green relative z-20 text-base leading-[1.2] lg:(text-xl)">
              {subtitle}
            </div>
            <div tw="text-tan relative z-20 text-2xl leading-[0.965] my-4 lg:(text-3xl)">
              {title}
            </div>
            <Link
              to={href || "/"}
              css={[buttonGreenViolet, tw`inline-block w-auto min-w-[11.8125rem] relative z-20`]}
            >
              {buttontxt}
            </Link>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Callout
